import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import ALink from '~/components/features/custom-link';
import TruncatedTooltip from '~/components/common/truncated-tooltip';
import { awardHref, cardPoints } from '~/utils/productGroup';
import { useAwardSearch } from '~/hooks/useAwardSearch';
import { useProgram } from '~/hooks/useProgram';

// Buscador mobile: un ícono de lupa (solo < lg) que abre un modal con el input
// y resultados en vivo (debounced). En desktop se usa el buscador inline.
// Cierra con la X, click en el overlay o Escape.
function MobileSearch() {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');

  const { program } = useProgram();
  const { results, isActive } = useAwardSearch(search);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  const close = () => setOpen(false);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!search.trim()) return;
    router.push({ pathname: '/search', query: { search } });
    setSearch('');
    close();
  };

  return (
    <>
      <button
        type="button"
        className="mobile-search-toggle"
        aria-label="Buscar"
        onClick={() => setOpen(true)}
      >
        <i className="d-icon-search"></i>
      </button>

      {open && (
        <div className="mobile-search-modal" role="dialog" aria-modal="true">
          <div className="mobile-search-overlay" onClick={close}></div>
          <div className="mobile-search-panel">
            <div className="mobile-search-bar">
              <form className="mobile-search-form" onSubmit={onSubmit}>
                <input
                  type="text"
                  className="form-control"
                  autoFocus
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Buscar premios..."
                />
                <button type="submit" className="btn btn-search" aria-label="Buscar">
                  <i className="d-icon-search"></i>
                </button>
              </form>
              <button
                type="button"
                className="mobile-search-close"
                aria-label="Cerrar"
                onClick={close}
              >
                <i className="d-icon-times"></i>
              </button>
            </div>

            {isActive && (
              <ul className="mobile-search-results">
                {results.map((item) => (
                  <li key={item.id}>
                    <ALink href={awardHref(item).href} as={awardHref(item).as} onClick={close}>
                      <img
                        src={item.award.mainImage}
                        width={44}
                        height={44}
                        alt={item.award.name}
                      />
                      <TruncatedTooltip>
                        <span className="msr-name">{item.award.name}</span>
                      </TruncatedTooltip>
                      <span className="msr-points">
                        {cardPoints(item).from ? 'Desde ' : ''}
                        {cardPoints(item).points.toLocaleString('es')} {program?.coinName}
                      </span>
                    </ALink>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default MobileSearch;
